import Image from "next/image"
import React from "react"

interface StatusStepProps {
  imageLink: string
  stepCompleted?: boolean
  hideProgress?: boolean
  isCurrentStep?: boolean
}

const StatusStep: React.FC<StatusStepProps> = ({
  imageLink,
  hideProgress = false,
  stepCompleted,
  isCurrentStep,
}) => {
  return (
    <div className="flex w-full ">
      <div className="grid grid-cols-12 items-center w-full">
        <div
          className={`items-center flex ${
            hideProgress
              ? "col-span-4 xs:col-span-6"
              : "justify-center col-span-2 xs:col-span-4 md:col-span-3"
          }`}
        >
          <Image src={imageLink} priority={true} width={30} height={30} />
        </div>
        {!hideProgress && (
          <div className="col-span-10 xs:col-span-8 md:col-span-9">
            <div className="grow flex items-center justify-center w-full relative">
              <div
                className={`w-full rounded-md my-auto absolute ${
                  stepCompleted ? "bg-black" : "bg-kosmoLightGray"
                }`}
                style={{
                  height: 6,
                  width: "90%",
                  zIndex: 3,
                }}
              />
              {isCurrentStep && (
                <div
                  className={`w-full rounded-md my-auto absolute bg-black`}
                  style={{
                    left: 0,
                    height: 6,
                    width: "45%",
                    zIndex: 5,
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default StatusStep
